export default __webpack_public_path__ + "static/media/person-icon.44e44a6b.svg";